// Routes — espace personnel de tout connecté (support, profil, séances, outils, correcteur, e-learning).
// Lot 7.6 (2026-10-17) : App.tsx éclaté par domaine, enfants de <Routes> recopiés
// tels quels (ordre et commentaires), aucune URL changée ; rendu en fragment dans
// l'ordre d'origine par App.tsx.
import { lazy, Suspense } from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../components/ProtectedRoute";
import { LoadingFallback } from "./communs";

export const ApportsEtape4Page = lazy(() => import("../pages/ApportsEtape4Page"));
export const ExercicesManuelPage = lazy(() => import("../pages/ExercicesManuelPage"));
export const ClarificationEtape2Page = lazy(() => import("../pages/ClarificationEtape2Page"));
export const EspacePersoPage = lazy(() => import("../pages/EspacePersoPage"));
export const KaraokePage = lazy(() => import("../pages/KaraokePage"));
export const OutilsCodevPage = lazy(() => import("../pages/OutilsCodevPage"));
export const CorpusTranscripteurPage = lazy(() => import("../pages/CorpusTranscripteurPage"));
export const CorpusLivePage = lazy(() => import("../pages/CorpusLivePage"));
export const TranscriptionOutilPage = lazy(() => import("../pages/TranscriptionOutilPage"));
// Correcteur RS7137 (accessible via Espace Perso / Mes Outils)
export const CorrecteurPage = lazy(() => import("../pages/CorrecteurPage"));
export const SessionCertificationPage = lazy(() => import("../pages/SessionCertificationPage"));
export const CandidatEpreuvePage = lazy(() => import("../pages/CandidatEpreuvePage"));
export const CorrectionPage = lazy(() => import("../pages/CorrectionPage"));
export const CasPratiqueEditPage = lazy(() => import("../pages/CasPratiqueEditPage"));
export const JuryWorkspacePage = lazy(() => import("../pages/JuryWorkspacePage"));
export const MesSeancesPage = lazy(() => import("../pages/MesSeancesPage"));
export const MesGroupesDetailPage = lazy(() => import("../pages/MesGroupesDetailPage"));
export const AdminSupportPage = lazy(() => import("../pages/AdminSupportPage"));
export const AdminSupportTechniquePage = lazy(() => import("../pages/AdminSupportPage").then(m => ({ default: m.AdminSupportTechniquePage })));
export const AdminDemandesPedaCommPage = lazy(() => import("../pages/AdminSupportPage").then(m => ({ default: m.AdminDemandesPedaCommPage })));
export const EntrainementPage = lazy(() => import("../pages/EntrainementPage"));
export const EntrainementDetailPage = lazy(() => import("../pages/EntrainementDetailPage"));
export const ELearningPage = lazy(() => import("../pages/ELearningPage"));
export const ContratOuvertPage = lazy(() => import("../pages/ContratOuvertPage"));
export function routesEspacePerso() {
  return (
    <>
{/* Support & contact — page unique avec 5 onglets (taxonomie 0095).
          Les deux anciennes routes sont conservées : elles pointent sur la même
          page et positionnent l'onglet via ?tab=bug ou ?tab=peda. */}
      <Route
        path="/plateforme/support"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]} orgPlateformeOnly>
            <Suspense fallback={<LoadingFallback />}>
              <AdminSupportPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/plateforme/support-technique"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]} orgPlateformeOnly>
            <Suspense fallback={<LoadingFallback />}>
              <AdminSupportTechniquePage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/plateforme/demandes-peda-commerciales"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]} orgPlateformeOnly>
            <Suspense fallback={<LoadingFallback />}>
              <AdminDemandesPedaCommPage />
            </Suspense>
          </ProtectedRoute>
        }
      />

      {/* Profil & Séances — tous les authentifiés */}
      <Route
        path="/mon-espace/profil"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <EspacePersoPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/mon-espace/outils"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <OutilsCodevPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/mon-espace/outils/karaoke"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <KaraokePage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/mon-espace/outils/transcription"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE", "ANIMATEUR"]}>
            <Suspense fallback={<LoadingFallback />}>
              <TranscriptionOutilPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/mon-espace/outils/transcripteur-recherche"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE", "ANIMATEUR"]}>
            <Suspense fallback={<LoadingFallback />}>
              <CorpusTranscripteurPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/mon-espace/outils/transcripteur-recherche/live/:seanceId"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE", "ANIMATEUR"]}>
            <Suspense fallback={<LoadingFallback />}>
              <CorpusLivePage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/mon-espace/outils/correcteur"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <CorrecteurPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/mon-espace/outils/correcteur/sessions/:id"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <SessionCertificationPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/mon-espace/outils/correcteur/epreuve/:candidatureId"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <CandidatEpreuvePage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/mon-espace/outils/correcteur/correction/:candidatureId"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <CorrectionPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/mon-espace/outils/correcteur/cas-pratiques/:id"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <CasPratiqueEditPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/mon-espace/outils/correcteur/sessions/:id/jury"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <JuryWorkspacePage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/mon-espace/e-learning"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <ELearningPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/mon-espace/e-learning/contrat-ouvert"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <ContratOuvertPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      {/* Module Vert — étape 2 : intervenir ou pas, et quel axe COODEV */}
      <Route
        path="/mon-espace/e-learning/clarification-etape-2"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <ClarificationEtape2Page />
            </Suspense>
          </ProtectedRoute>
        }
      />
      {/* Module Vert — étape 4 : piste d'action ou piste de réflexion */}
      <Route
        path="/mon-espace/e-learning/apports-etape-4"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <ApportsEtape4Page />
            </Suspense>
          </ProtectedRoute>
        }
      />
      {/* Routes e-learning SANS orgPlateformeOnly (lot 5 certifications,
          2026-10-06) : l'accès se décide par PARCOURS côté serveur (403
          PARCOURS_REQUIS), pas par l'org active — un alumni d'une org
          cliente garde son e-learning. */}
      {/* Module Vert — exercices du manuel (sans LLM) : une page générique,
          la clé d'URL choisit la banque (manuel-etape1-manchettes, …). */}
      <Route
        path="/mon-espace/e-learning/manuel/:cle"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <ExercicesManuelPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/mon-espace"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <MesSeancesPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/mon-espace/entrainement"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <EntrainementPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/mon-espace/entrainement/:id"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <EntrainementDetailPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/mon-espace/groupes/:groupeId"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <MesGroupesDetailPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
    </>
  );
}
